import { OTPConstants } from '../Constants';

export function Telco(state = {}, action) {
    switch (action.type) {
        case OTPConstants.POST_OTP_REQUEST:
            return {
                ...state,
                postloading: true
            };
        case OTPConstants.POST_OTP_SUCCESS:
            return {
                ...state,
                postloading: false,
                getResult: action.OTP
            };
        case OTPConstants.POST_OTP_FAILURE:
            return {
                ...state,
                postloading: false,
                postError: action.error
            };
        case OTPConstants.POST_VERIFY_OTP_REQUEST:
            return {
                ...state,
                postloading: true
            };
        case OTPConstants.POST_VERIFY_OTP_SUCCESS:
            return {
                ...state,
                postloading: false,
                postResult: action.OTP
            };
        case OTPConstants.POST_VERIFY_OTP_FAILURE:
            return {
                ...state,
                postloading: false,
                postError: action.error
            };
        default:
            return state
    }
}